package com.essntl.features.crm.domain.model

data class ContactOrganizationModel(
    val id: String,
    val name: String,
    val email: String?,
    val organizationId: String?,
)